import type { ReactNode } from 'react';

export const symbol_browse_activity: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M80-590v-190q0-24 18-42t42-18h680q24 0 42 18t18 42v190h-60v-190H140v190H80Zm60 350q-24 0-42-18t-18-42v-230h60v230h680v-230h60v230q0 24-18 42t-42 18H140ZM70-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-180 70-180h820q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H70Zm410-420ZM80-530v-60h240q8.16 0 15.58 4T347-574l55 112 131-231q4-8 11.5-11.5t15.62-3.5q8.12 0 15.5 3.5Q583-701 587-693l50.55 103H880v60H619q-8.25 0-15.75-4T592-546l-34-69-131 229q-3.72 8-11.17 12-7.45 4-15.64 4-8.19 0-15.69-4T373-386l-72-144H80Z"
		/>
	</svg>
);
